import { render, staticRenderFns } from "./BottomBarResult.vue?vue&type=template&id=4673a82a&"
import script from "./BottomBarResult.vue?vue&type=script&lang=ts&"
export * from "./BottomBarResult.vue?vue&type=script&lang=ts&"
import style0 from "./BottomBarResult.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports